<script>
import MainLayout from '../layouts/mainLayout'
import googleMap from '@/components/googleMap'
import moment from 'moment'
import Stomp from 'stompjs'
import {CommonConstant} from '@/utils/CommonConstant.js'
import NORMAL_POSITION_ICON from '../../assets/map_icon/map_car_position.png'
// import BA_HOUR_POSITION_ICON from '../../assets/map_icon/map_car_position.png'
import RADIO_TROUBLE_POSITION_ICON from '../../assets/map_icon/map_car_gps_not_reach.png'
import TROUBLE_POSITION_ICON from '../../assets/map_icon/map_car_in _trouble.png'
import DELAY_POSITION_ICON from '../../assets/map_icon/map_car_delay.png'

import tblMP3 from '@/assets/mp3/trouble.mp3'
export default {
  data () {
    return {
      functionId: 'MovementStatus',
      mapId: 'mapMovementStatus',
      // 地图中心点
      centerPoint: {
        lat: null,
        lng: null
      },
      // 最大经纬度
      maxVehiclePoint: {lat: 0, lng: 0},
      // 最小经纬度
      minVehiclePoint: {lat: 0, lng: 0},
      // 地图标记点List
      pointDataList: [],
      markList: [],
      infowindowList: [],
      shiftInfos: [],
      inServiceCount: 0,
      shiftMovementStatus: [
        '業務前',
        '業務中',
        '業務終了',
        '強制終了'
      ],
      shiftPasspoints: [],
      // 运行中车辆编码
      vehicleIndex: [],
      titleBg: [
        'bgc1',
        'bgc4',
        'bgc3',
        'bgc3'
      ],
      contentBg: [
        'bgc7',
        'bgc7',
        'bgc2',
        'bgc2'
      ],
      statusList: [],
      // MQ URL
      MQ_URL: '',
      // MQ 登录名
      MQ_LOGIN: '',
      // MQ 登录密码
      MQ_PASSCODE: '',
      // MQ 队列名
      MQ_DESTINATION: '',
      // 超时时间
      MQ_TIME_OUT: 0,
      // MQ client
      client: null
    }
  },
  computed: {
  },
  components: {MainLayout, googleMap},
  beforeMount () {
    this.$axios.get('shift/queryTodayShiftInfos')
      .then(response => {
        this.shiftInfos = response.data.shiftInfos
        this.inServiceCount = response.data.inServiceCount
        let mqConfiguration = response.data.mqConfiguration
        this.MQ_URL = mqConfiguration.mqUrl
        this.MQ_LOGIN = mqConfiguration.mqUserName
        this.MQ_PASSCODE = mqConfiguration.mqPassword
        this.MQ_DESTINATION = mqConfiguration.mqDestination
        this.MQ_TIME_OUT = mqConfiguration.communicationTimeOut
        this.prepareData()
        this.getMQMess()
        setInterval(() => {
          for (let point of this.pointDataList) {
            let nowTime = moment().format('YYYYMMDDHHmmssSSS')
            if (point.tTime && this.isTimeOut(point.tTime, nowTime) === false) {
              point.communicationFlag = 0
            } else if (this.isTimeOut(point.pTime, nowTime) || this.isTimeOut(point.mTime, nowTime)) {
              point.communicationFlag = 1
            } else {
              point.communicationFlag = 0
            }
          }
          this.drawMark()
        }, 20 * 1000)
      })
      .catch(error => {
        console.log(error)
      })
  },
  mounted () {
    // 回到一览界面清除session的shiftDetail
    if (JSON.parse(sessionStorage.getItem('shiftDetail')) !== null) {
      sessionStorage.removeItem('shiftDetail')
    }
  },
  methods: {
    // 准备数据
    prepareData (mqFlag, type, shiftId) {
      this.pointDataList = []
      // 判断状态
      this.statusList = []
      for (let shiftInfo of this.shiftInfos) {
        this.statusList.push(this.checkMoveShiftStatus(shiftInfo))
      }
      // 画点
      new Promise((resolve, reject) => {
        // 编码
        let index = 0
        // 车的编号
        this.vehicleIndex = []

        for (let shiftInfo of this.shiftInfos) {
          // 不是业务中的便车编号为0
          if (shiftInfo.businessStatus !== 2) {
            this.vehicleIndex.push(0)
          }
          // 业务前不画点
          if (shiftInfo.businessStatus === 2) {
            // 点的图标
            let icon
            // 通信故障标志 1为通信障害 0为通信正常
            let communicationFlag = 0
            // 设置通信障害标志
            if (mqFlag && shiftId === shiftInfo.shiftId) {
              communicationFlag = 0
            } else {
              if (shiftInfo.positionUpdateTime && shiftInfo.positionUpdateTime.length === 17) {
                let updateTime = moment(shiftInfo.positionUpdateTime, 'YYYYMMDDHHmmssSSS')
                updateTime.add(this.MQ_TIME_OUT, 'seconds')
                if (updateTime.isBefore(new Date())) {
                  communicationFlag = 1
                }
              }
            }
            // 设置车辆编号
            // index = index + 1
            if(shiftInfo.groupNum === null){
              index = ''
            }else{
              if (shiftInfo.rowNum === '0') {
                this.vehicleIndex.push(shiftInfo.groupNum)
                index = shiftInfo.groupNum
              } else {
                this.vehicleIndex.push(shiftInfo.groupNum + '-' + shiftInfo.rowNum)
                index = shiftInfo.groupNum + '-' + shiftInfo.rowNum
              }
            }

            // 设置ICON和大小
            let iconSize
            if (communicationFlag === 1) {
              icon = RADIO_TROUBLE_POSITION_ICON
              iconSize = {
                width: 60,
                height: 85
              }
            } else if (shiftInfo.lateFlag === 1) {
              icon = DELAY_POSITION_ICON
              iconSize = {
                width: 60,
                height: 120
              }
            } else if (shiftInfo.troubleFlag === 1) {
              icon = TROUBLE_POSITION_ICON
              iconSize = {
                width: 60,
                height: 120
              }
            } else {
              icon = NORMAL_POSITION_ICON
              iconSize = {
                width: 60,
                height: 85
              }
            }
            // 查找最大最小经纬度
            if (shiftInfo.vehicleLat && shiftInfo.vehicleLng) {
              if (this.maxVehiclePoint.lat === 0) {
                this.maxVehiclePoint.lat = shiftInfo.vehicleLat
                this.maxVehiclePoint.lng = shiftInfo.vehicleLng
              }
              if (this.minVehiclePoint.lat === 0) {
                this.minVehiclePoint.lat = shiftInfo.vehicleLat
                this.minVehiclePoint.lng = shiftInfo.vehicleLng
              }
              if (shiftInfo.vehicleLat > this.maxVehiclePoint.lat) {
                this.maxVehiclePoint.lat = shiftInfo.vehicleLat
              }
              if (shiftInfo.vehicleLng > this.maxVehiclePoint.lng) {
                this.maxVehiclePoint.lng = shiftInfo.vehicleLng
              }
              if (shiftInfo.vehicleLat < this.minVehiclePoint.lat) {
                this.minVehiclePoint.lat = shiftInfo.vehicleLat
              }
              if (shiftInfo.vehicleLng < this.minVehiclePoint.lng) {
                this.minVehiclePoint.lng = shiftInfo.vehicleLng
              }

              this.pointDataList.push({
                shiftId: shiftInfo.shiftId,
                index: index,
                // 图标编码
                stationId: icon === RADIO_TROUBLE_POSITION_ICON ? '' : '' + index,
                stationLat: shiftInfo.vehicleLat,
                stationLng: shiftInfo.vehicleLng,
                // 延迟标志 1延迟 0正常
                lateFlag: shiftInfo.lateFlag,
                // 故障标志 1故障 0正常
                troubleFlag: shiftInfo.troubleFlag,
                // 是否更新 用于判断通信是否成功 1障害 0正常
                communicationFlag: communicationFlag,
                // 位置更新时间
                pTime: shiftInfo.positionUpdateTime,
                // MQ接收时间
                mTime: moment().format('YYYYMMDDHHmmssSSS'),
                // 故障时间
                tTime: null,
                // 点的图标
                icon: icon,
                iconSize: iconSize
              })
            }
          }
        }
        resolve()
      }).then(() => {
        if (!mqFlag) {
          // 初始化地图
          this.$refs.gMap.initializeGoogleMap().then(() => {
            if (this.$refs.gMap) {
              this.setZoom()
              let imgSize = {width: 60, height: 85}
              let labelAnchor = {width: 30, height: 45}
              this.markList = this.$refs.gMap.addMark(imgSize, 'movement-status-label-class', labelAnchor, true)
              this.setMarkListInfo()
            }
          })
        } else {
          if (this.$refs.gMap) {
            if (type === 1 || type === 3) {
              this.setZoom()
            }

            let imgSize = {width: 60, height: 85}
            let labelAnchor = {width: 30, height: 45}
            // 制空点
            for (let i = 0; i < this.markList.length; i++) {
              this.markList[i].setMap(null)
            }
            this.markList = this.$refs.gMap.addMark(imgSize, 'movement-status-label-class', labelAnchor, true)
            this.setMarkListInfo()
          }
        }
      })
    },
    isTimeOut (oldT, newT) {
      let newTime = moment(newT, 'YYYYMMDDHHmmssSSS')
      let oldTime = moment(oldT, 'YYYYMMDDHHmmssSSS')
      oldTime.add(this.MQ_TIME_OUT, 'seconds')
      if (oldTime.isBefore(newTime)) {
        return true// 过期
      }
      return false// 未过期
    },
    // 设置合适的比例尺和中心点
    setZoom () {
      // 设置中心点和比例尺
      if (this.maxVehiclePoint.lat && this.maxVehiclePoint.lng && this.minVehiclePoint.lat && this.minVehiclePoint.lng) {
        // 设置中心点
        this.$refs.gMap.map.setCenter({
          lat: (this.maxVehiclePoint.lat + this.minVehiclePoint.lat) / 2,
          lng: (this.maxVehiclePoint.lng + this.minVehiclePoint.lng) / 2
        })
        let lngDistance = this.$refs.gMap.getDistance(this.maxVehiclePoint.lng, this.maxVehiclePoint.lat, this.minVehiclePoint.lng, this.maxVehiclePoint.lat)
        let latDistance = this.$refs.gMap.getDistance(this.maxVehiclePoint.lng, this.maxVehiclePoint.lat, this.maxVehiclePoint.lng, this.minVehiclePoint.lat)
        let distance
        if (lngDistance > latDistance) {
          distance = lngDistance
        } else {
          distance = latDistance
        }
        let level = this.$refs.gMap.getScaleLevel(distance)
        this.$refs.gMap.map.setZoom(level)
      } else {
        this.$refs.gMap.map.setZoom(14)
      }
    },
    // 动态画点
    drawMark () {
      for (let i = 0; i < this.markList.length; i++) {
        let marker = this.markList[i]
        let point = this.pointDataList[i]
        marker.setMap(null)
        // 根据不同状态修改点的图标
        if (point.communicationFlag === 1) {
          point.icon = RADIO_TROUBLE_POSITION_ICON
          point.iconSize = {
            width: 60,
            height: 85
          }
          point.stationId = ''
        } else if (point.lateFlag === 1) {
          point.icon = DELAY_POSITION_ICON
          point.iconSize = {
            width: 60,
            height: 120
          }
          point.stationId = point.index
        } else if (point.troubleFlag === 1) {
          point.icon = TROUBLE_POSITION_ICON
          point.iconSize = {
            width: 60,
            height: 120
          }
          point.stationId = point.index
        } else {
          point.icon = NORMAL_POSITION_ICON
          point.iconSize = {
            width: 60,
            height: 85
          }
          point.stationId = point.index
        }
      }
      // // 设置中心点
      // if (this.pointDataList.length !== 0) {
      //   this.centerPoint = {
      //     lat: this.pointDataList[0].stationLat,
      //     lng: this.pointDataList[0].stationLng
      //   }
      //   if (this.$refs.gMap) {
      //     this.$refs.gMap.map.setCenter(this.centerPoint)
      //   }
      // }
      if (this.$refs.gMap) {
        let imgSize = {width: 60, height: 85}
        let labelAnchor = {width: 30, height: 45}
        this.markList = this.$refs.gMap.addMark(imgSize, 'movement-status-label-class', labelAnchor, true)
        this.setMarkListInfo()
      }
    },
    // 修改单个点
    drawSingleMark (index) {
      let marker = this.markList[index]
      let point = this.pointDataList[index]
      marker.setMap(null)
      // 根据不同状态修改点的图标
      if (point.communicationFlag === 1) {
        point.icon = RADIO_TROUBLE_POSITION_ICON
        point.iconSize = {
          width: 60,
          height: 85
        }
        point.stationId = ''
      } else if (point.lateFlag === 1) {
        point.icon = DELAY_POSITION_ICON
        point.iconSize = {
          width: 60,
          height: 120
        }
        point.stationId = point.index
      } else if (point.troubleFlag === 1) {
        point.icon = TROUBLE_POSITION_ICON
        point.iconSize = {
          width: 60,
          height: 120
        }
        point.stationId = point.index
      } else {
        point.icon = NORMAL_POSITION_ICON
        point.iconSize = {
          width: 60,
          height: 85
        }
        point.stationId = point.index
      }

      // 设置中心点
      // if (this.pointDataList.length !== 0) {
      //   this.centerPoint = {
      //     lat: this.pointDataList[0].stationLat,
      //     lng: this.pointDataList[0].stationLng
      //   }
      //   if (this.$refs.gMap) {
      //     this.$refs.gMap.map.setCenter(this.centerPoint)
      //   }
      // }
      if (this.$refs.gMap) {
        let labelAnchor = {width: 30, height: 45}
        let singlePoint = {
          label: point.stationId,
          lat: point.stationLat,
          lng: point.stationLng,
          icon: point.icon,
          iconSize: point.iconSize,
          clickable: true
        }
        let newMarker = this.$refs.gMap.addSingleMaker(singlePoint, null, 'movement-status-label-class', labelAnchor)
        this.$set(this.markList, index, newMarker)
        this.setMarkListInfo()
      }
    },
    // 设置MarkList的信息
    setMarkListInfo () {
      for (let infowindow of this.infowindowList) {
        infowindow.close()
      }
      this.infowindowList = []
      for (let i = 0; i < this.markList.length; i++) {
        // 鼠标点击图标事件
        this.markList[i].addListener('click', () => {
          this.$router.push({name: 'MovementStatusDetail', query: {shiftId: this.pointDataList[i].shiftId}})
        })
        // 通信障害时提示
        if (this.pointDataList[i].icon === RADIO_TROUBLE_POSITION_ICON) {
          // 定义信息
          var infowindow = new global.google.maps.InfoWindow({
            content: '車両の通信状態が不安定です。'
          })
          infowindow.open(this.$refs.gMap.map, this.markList[i])
          this.infowindowList.push(infowindow)
        }
      }
    },
    goMovementStatusDetail (shiftInfo, index) {
      this.$router.push({name: 'MovementStatusDetail', query: {shiftId: shiftInfo.shiftId}})
    },
    goToTable (shiftInfo, shiftPasspoints, businessStatus) {
      console.log("gotoTable")
      console.log(shiftInfo)
      // sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: shiftInfo, shiftPasspoints: shiftPasspoints}))
      if (businessStatus === 3) {
        // this.$router.push({ name: 'ShiftEndDetail', query: {shiftId: shiftInfo.shiftId}})
        this.$router.push({path: '/ShiftEndDetail', query: {shiftId: shiftInfo.shiftId, flag: true, from: 'MovementStatus'}})
      } else {
        let parentShiftId
        if(shiftInfo.parentShiftId == '' || shiftInfo.parentShiftId == null){
          parentShiftId = shiftInfo.shiftId
        }else{
          parentShiftId = shiftInfo.parentShiftId
        }
        this.$axios.get('shift/queryShiftInfoListByParentShiftId', {params: {parentShiftId: parentShiftId}}).then(response => {
          let shiftInfoList
          let allConnectShiftsCanEdit = true
          console.log("queryShiftInfoListByParentShiftId")
          console.log(response.data.shiftInfoList)
          shiftInfoList = response.data.shiftInfoList
          for (let shiftInfoTemp of shiftInfoList) {
          
            // 接続便の状態チェック
            if(shiftInfoTemp.businessStatus == 2){
              console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務開始」です")
              allConnectShiftsCanEdit = false
            }else if(shiftInfoTemp.businessStatus == 3){
              console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務終了」です")
              allConnectShiftsCanEdit = false
            }
          }
          // this.$router.push({ path: '/ShiftWithEventDetail' })
          this.$router.push({path: '/ShiftWithEventDetail', query: {shiftId: shiftInfo.shiftId, flag: true, from: 'MovementStatus', allConnectShiftsCanEdit: allConnectShiftsCanEdit, transportKind: shiftInfo.transportKind}})
        })
      }
      // event.stopPropagation()
    },
    getMQMess () {
      var url = this.MQ_URL
      var login = this.MQ_LOGIN
      var passcode = this.MQ_PASSCODE
      var destination = '/topic/' + this.MQ_DESTINATION
      // 本地测试
      // var url = 'ws://127.0.0.1:61614?maximumConnections=1000&amp;wireFormat.maxFrameSize=104857600'
      // var login = 'admin'
      // var passcode = 'admin'
      // var destination = '/topic/TransportationServiceQueue'

      this.client = Stomp.client(url, CommonConstant.MQ_STOMP_CLIENT)
      this.client.heartbeat.outgoing = 10000
      this.client.heartbeat.incoming = 0
      this.client.connect(login, passcode, frame => {
        this.client.subscribe(destination, message => {
          let mess = JSON.parse(message.body)
          switch (mess.type) {
            case 1:
              // 更新车辆位置
              this.updateVehiclePosition(mess)
              break
            case 2:
              // 更新车辆故障
              this.updateTrouble(mess)
              break
            case 3:
              // 运行开始
              this.updateToMoveStart(mess)
              break
            case 5:
              // 运行结束
              this.updateToMoveEnd(mess)
              break
            case 6:
              // 业务开始
              this.updateToBusinessStart(mess)
              break
            case 7:
              // 业务结束
              this.updateToBusinessEnd(mess)
              break
          }
        })
      })
    },
    // 更新位置
    updateVehiclePosition (mess) {
      // 车辆点不存在标志
      let isExist = false
      let shift = null
      // 更新shiftInfo的车辆经纬度
      for (let shiftInfo of this.shiftInfos) {
        if (shiftInfo.shiftId === mess.data.shiftId) {
          shiftInfo.vehicleLat = mess.data.position.lat
          shiftInfo.vehicleLng = mess.data.position.lng
          shiftInfo.positionUpdateTime = mess.data.position.time
          shift = shiftInfo
          break
        }
      }
      // 修改点
      for (let i = 0; i < this.pointDataList.length; i++) {
        let point = this.pointDataList[i]
        if (point.shiftId === mess.data.shiftId) {
          point.stationLat = mess.data.position.lat
          point.stationLng = mess.data.position.lng
          // 判断是否通信障害
          let mqTime = moment().format('YYYYMMDDHHmmssSSS')
          if (this.isTimeOut(mess.data.position.time, mqTime)) {
            point.communicationFlag = 1
          } else {
            point.communicationFlag = 0
          }
          point.pTime = mess.data.position.time
          point.mTime = moment().format('YYYYMMDDHHmmssSSS')
          isExist = true
          this.drawSingleMark(i)
          break
        }
      }
      // 运行中但是没有点
      if (!isExist && shift && shift.businessStatus === 2) {
        this.prepareData(true, 1, mess.data.shiftId)
      }
    },
    // 更新车辆trouble
    updateTrouble (mess) {
      // 更新trouble
      for (let i = 0; i < this.pointDataList.length; i++) {
        let point = this.pointDataList[i]
        if (point.shiftId === mess.data.shiftId) {
          point.troubleFlag = 1

          // 判断是否通信障害
          let mqTime = moment().format('YYYYMMDDHHmmssSSS')
          // if (this.isTimeOut(point.pTime, mqTime)) {
          //   point.communicationFlag = 1
          // } else {
          //   point.communicationFlag = 0
          // }
          point.tTime = mqTime
          point.mTime = mqTime
          point.communicationFlag = 0
          this.drawSingleMark(i)
          this.playVideo(tblMP3)
          break
        }
      }
    },
    // 运行开始
    updateToMoveStart (mess) {
      for (let shiftInfo of this.shiftInfos) {
        if (shiftInfo.shiftId === mess.data.shiftId) {
          shiftInfo.shiftMovementStatus = 2
          shiftInfo.vehicleLat = mess.data.position.lat
          shiftInfo.vehicleLng = mess.data.position.lng
          break
        }
      }
    },
    // 运行结束
    updateToMoveEnd (mess) {
      for (let shiftInfo of this.shiftInfos) {
        if (shiftInfo.shiftId === mess.data.shiftId) {
          shiftInfo.shiftMovementStatus = 3
          break
        }
      }
    },
    // 业务开始
    updateToBusinessStart (mess) {
      for (let shiftInfo of this.shiftInfos) {
        if (shiftInfo.shiftId === mess.data.shiftId) {
          shiftInfo.businessStatus = 2
          shiftInfo.vehicleLat = mess.data.position.lat
          shiftInfo.vehicleLng = mess.data.position.lng
          this.inServiceCount += 1
          this.prepareData(true, 3, mess.data.shiftId)
          break
        }
      }
    },
    // 业务结束
    updateToBusinessEnd (mess) {
      for (let shiftInfo of this.shiftInfos) {
        if (shiftInfo.shiftId === mess.data.shiftId) {
          shiftInfo.businessStatus = 3
          this.inServiceCount -= 1
          this.prepareData(true, 5, mess.data.shiftId)
          break
        }
      }
    },
    playVideo (mp3) {
      let video = new Audio(mp3)
      try {
        video.play()
      } catch (error) {
        console.error(error)
      }
    },
    checkMoveShiftStatus (shiftInfo) {
      // 判断是否强制终了
      if (shiftInfo.coercionStopFlag === 1) {
        return 4
      }

      return shiftInfo.businessStatus
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.client && this.client.connected) {
      this.client.disconnect()
    }
    next()
  }
}
</script>

<template>
  <MainLayout>
    <!-- header -->
    <div class="row clearfix header">
      <div class="col-md-3 column statusheaderleft F4-M-20">
        業務中車両:{{inServiceCount}}台
      </div>
      <div class="headermiddle F3-M-27">
        運行状況一覧
      </div>
    </div>
    <!-- body -->
    <div class="col-md-12 column" style="height: 100%;">
      <div class="row clearfix" style="height: 100%;">
        <div class="col-md-5 column home-left" style="height: 100%;">
          <div class="home-list slider" style="overflow-y:scroll">
            <div v-for="(shiftInfo,key) in shiftInfos" :key="key" class="shiftStatusList" @click="goMovementStatusDetail(shiftInfo,key)">
              <!-- title -->
              <div class="home-title" :class="titleBg[statusList[key]-1]">
                <div class="col-md-6 column home-title-left home-time F2-M-20">
                  <div class="shift-title" :title="shiftInfo.title">
                    <img src="../../assets/icon/transport_kind0.png" style="height: 32px;width:32px;" v-if="shiftInfo.transportKind=='0'">
                    <img src="../../assets/icon/transport_kind1.png" style="height: 32px;width:32px;" v-if="shiftInfo.transportKind=='1'">
                    <img src="../../assets/icon/app_use.png" style="height: 32px;width:32px;" v-if="shiftInfo.routeType=='1'">
                    <img src="../../assets/icon/app_dontuse.png" style="height: 32px;width:32px;" v-if="shiftInfo.routeType=='2'">
                    {{shiftInfo.title}}</div>
                  <div v-if="vehicleIndex[key]!=0" class="index-div">{{vehicleIndex[key]}}</div>
                </div>
                <div class="col-md-6 column home-title-right F2-M-20">{{shiftMovementStatus[statusList[key]-1]}}</div>
              </div>
              <!-- content -->
              <div class="home-content" :class="['statusBorder'+statusList[key],contentBg[statusList[key]-1]]">
                <div class="home-frist">
                  <div class="home-title-left home-time">
                    <span class="driver-key F3-M-16">[ドライバー]</span>&nbsp;
                    <span class="driver-value F3-M-22" :title="shiftInfo.driverLastName+' '+shiftInfo.driverFirstName">{{shiftInfo.driverLastName}}&nbsp;{{shiftInfo.driverFirstName}}</span>
                  </div>
                  <div class="detail-div">
                    <button class="btn detail-btn F2-M-16" @click.stop="goToTable(shiftInfo,shiftInfo.shiftPasspoints,shiftInfo.businessStatus)">詳細</button>
                  </div>
                </div>
                <div class="col-md-12 column home-content-div">
                  <div class="home-title-left home-time">
                    <div class="col-md-4 column div-style">
                      <span class="F3-R-17">車両ID : {{shiftInfo.displayVehicleId}}
                      </span>
                    </div>
                    <div class="col-md-3 column vehicle-name F3-R-17" :title="shiftInfo.vehicleName">
                            車両 : {{shiftInfo.vehicleName}}
                    </div>
                    <div class="col-md-4 column div-style">
                      <span class="F3-R-17">定員 : {{shiftInfo.passengerNumber}}名</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7 column home-right">
          <googleMap ref="gMap" :centerPoint="centerPoint" :map-id="mapId" :point-list="pointDataList" />
        </div>
      </div>
    </div>

  </MainLayout>
</template>

<style scoped>
@import "../../assets/css/C00.css";
.header{
    margin-bottom: 2vh;
    height: 6vh;
    position: relative;
}
.headermiddle {
  margin-top: 20px;
  font-size: 25px;
  position: absolute;
  width: 100%;
}
.statusheaderleft{
  margin-top: 20px;
  margin-left: 15px;
  text-align: left;
  font-size: 18px;
  position: absolute;
  top: 40%;
}
.home-left{
  width: 39%;
  margin-top:10px;
}
.shiftStatusList{
  margin-bottom: 10px;
}

.home-list {
  width: 100%;
  /* height: 70vh; */
  height: calc(100% - 30px);
  /* 规定元素生成的框的类型 */
  display: inline-block;
  padding-right: 20px;
}
.detail-div{
  width:20%;
  height: 45px;
  display: flex;
  justify-content: center;
}
.detail-btn {
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
  color:#fff;
  font-size:15px;
  height:30px;
  width:80%;
  border-radius:5px;
  align-self: center;
  border: 0px;
}
/* title */
.home-title {
  color: #ffffff;
  height: 45px;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.home-title-left {
  width:80%;
  padding-left: 10px;
}
.home-title-right {
  width:20%;
  border-left: #fff solid 1px;
  margin: 10px 0;
  padding: 0px;
}

.home-time {
  display: flex;
  align-items: center;
  height: 100%;
}

.shift-title {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left
}

.driver-key{
  width: 24%;
  text-align: left
}
.driver-value{
  width: 76%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left
}

.index-div {
    background: white;
    color: rgb(54, 72, 165);
    width: 30px;
    height: 30px;
    border-radius: 5px;
    position: absolute;
    right: 10px;
    line-height: 30px;
    text-align: center;
    top: 7px;
    font-size: 16px;
}

.div-style{
  padding: 0px;
}

.vehicle-name{
  width:40%;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0px;
}

.home-content{
  /* background: #E6E6E6; */
  height: 85px;
  font-size: 18px;
  text-align: left;
  cursor:pointer;
}
.home-content-div{
  font-size: 14px;
  padding: 0px;
  height: 45%;
}
.home-frist{
  height: 55%;
  border-bottom: 1px dashed rgb(171, 171, 171);
  display: flex;
  align-items: center;
}

.home-right{
  margin-top: 10px;
  /* height: 70vh; */
  height: calc(100% - 30px);
  width: 61%;
  /* width: 500px; */
}

.list-item{
  border-bottom: #B9B9B9 solid 1px;
  border-top: #fff solid 1px;
  background: #DCDCDC;
  margin: 0px auto;
  padding-top: 8px;
  padding-bottom: 8px;
}
.radius {
  width: 60px;
  background: rgb(109, 109, 109);
  border-radius: 30px;
  color: #ffffff;
  text-align: center;
  font-size: 8px;
  margin-left: 5px;
}

/* .statusBg1{
  background: rgb(108, 162, 188);
}
.statusBg2{
  background: rgb(54, 72, 165);
}
.statusBg3{
  background: rgb(138, 138, 138);
} */
.statusBorder1{
  border: rgb(108, 162, 188) 3px solid;
}
.statusBorder2{
  border: rgb(54, 72, 165) 3px solid;
}
.statusBorder3{
  border: rgb(138, 138, 138) 3px solid;
}
.statusBorder4{
  border: rgb(138, 138, 138) 3px solid;
}
</style>



// WEBPACK FOOTER //
// src/router/views/MovementStatus.vue